export default __webpack_public_path__ + "static/media/vinos2-unsplash.9c009ad2.jpg";